import { api } from '../lib/api';
import type { Notification } from '../types/api';

export type NotificationType =
  | 'ORDER_PENDING_APPROVAL'
  | 'ORDER_DECISION'
  | 'LOAN_PENDING_APPROVAL'
  | 'LOAN_DECISION'
  | 'LOAN_CHECKED_OUT'
  | 'WARRANTY_ALERT'
  | 'INVOICE_READY'
  | 'CREDIT_NOTE_ISSUED';

export interface EmailPreference {
  type: NotificationType;
  label: string;
  emailEnabled: boolean;
}

export async function listNotifications(): Promise<Notification[]> {
  const { data } = await api.get<Notification[]>('/notifications');
  return data;
}

export async function getUnreadNotificationCount(): Promise<{ count: number }> {
  const { data } = await api.get<{ count: number }>('/notifications/unread-count');
  return data;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.patch('/notifications/read-all');
}

export async function listEmailPreferences(): Promise<EmailPreference[]> {
  const { data } = await api.get<EmailPreference[]>('/notifications/preferences');
  return data;
}

export async function updateEmailPreference(type: NotificationType, emailEnabled: boolean): Promise<EmailPreference[]> {
  const { data } = await api.patch<EmailPreference[]>('/notifications/preferences', { type, emailEnabled });
  return data;
}
